import type { RootState } from "@src/store/rootState";
import { basicModSlice } from "@src/store/slices/experienceBuilder/basicMod/slice";
import { componentSlice } from "@src/store/slices/experienceBuilder/component/slice";

export type ActiveFlowType = "basicMod" | "component";

export function getActiveFlowType(
  state: RootState
): ActiveFlowType | undefined {
  if (basicModSlice.selectors.isActive(state)) {
    return "basicMod";
  }
  if (componentSlice.selectors.isActive(state)) {
    return "component";
  }
  return undefined;
}
